import Vue from 'vue'
import vuetify from './plugins/vuetify'
import VueConfetti from 'vue-confetti'
import vueDebounce from 'vue-debounce'

import router from './router'
import App from './App'
import './assets/css/styles.css'

Vue.use(require('vue-moment'))
Vue.use(vuetify)
Vue.use(VueConfetti)
Vue.use(vueDebounce)

const theme = {
  thhs: {
    primary: '#940e11'
  }
}

new Vue({
  vuetify,
  router,
  theme: {
    themes: {
      thhs: theme
    }
  },
  render: h => h(App)
}).$mount('#app')
